import { Base64 } from 'js-base64';

import { apiDelete, apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { IUserInfo } from '../interfaces/IUserInfo';

export async function fetchLogin(username: string, password: string): Promise<void> {
  return apiPost<void>({
    url: '/public/auth/authenticator/api/internalauth/auth?loaderKey=default',
    isAccept: true,
    authorization: `Basic ${Base64.encode(`${username}:${password}`)}`,
  });
}

export async function fetchLogout(): Promise<void> {
  return apiDelete<void>('/public/auth/authenticator/api/internalauth/logout');
}

export async function fetchUserInfo(): Promise<IUserInfo> {
  return apiGet<IUserInfo>('/public/api/access-manager/api/users/current/extendedprofile', true);
}

export async function fetchUserInfoDetails(): Promise<{ isTestUser: boolean }> {
  return apiGet<{ isTestUser: boolean }>(`/erknm-catalogs/api/admin/users/current`, true, true);
}
